import React, { useReducer } from 'react'
import AppSheetContext from './appsheetContext'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_PRODUCT_DETAILS,
} from './appsheetTypes'
import appsheetReducer from './appsheetReducer'

const appsheetState = (props) => {
    const initialState = {
        responseStatus: {
            message: '',
            from: '',
            status: '',
        },
        product_details: {
            record: {},
            from: '',
        },
    }

    const [state, dispatch] = useReducer(appsheetReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const retrieveAppSheetProduct = async (
        formData,
        fromVariable = 'retrieveAppSheetProduct'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'retrieveAppSheetProduct',
                    formData,
                    '',
                    'third_party/appsheet'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_PRODUCT_DETAILS,
                    payload: {
                        record: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const syncAppSheetData = async (
        formData,
        fromVariable = 'syncAppSheetData'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'syncAppSheetData',
                    formData,
                    '',
                    'third_party/appsheet'
                ),
            ])
            if (res.data.status === 'success' || res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        message: res.data.data.message,
                        from: fromVariable,
                        status: res.data.status,
                    },
                })
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (e) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <AppSheetContext.Provider
            value={{
                responseStatus: state.responseStatus,
                product_details: state.product_details,
                retrieveAppSheetProduct,
                syncAppSheetData,
                clearResponse,
            }}
        >
            {props.children}
        </AppSheetContext.Provider>
    )
}
export default appsheetState
